module.exports = __webpack_public_path__ + "img/1_x1.61f7c60d.png";